import React, { useState, useEffect } from "react";
import { ComparisionViewButton, ChartWrapper, MainWrapper } from "../MetricDashboard.styles";
import { Loader } from "@vds/loaders";
import * as supportCaseType from "../../../api/metricDashboard/supportCaseType";
import { Chart } from "primereact/chart";
import ChartDataLabels from "chartjs-plugin-datalabels";
import Colors from "../../MetricDashboard/VCCPButtons/Colors";
import CPNotification from "../../Login/CPNotification";
import { Wrapper } from "../../../constants/common/StyledGlobalConstants";
import PropTypes from "prop-types";

const SupportCaseTypes = ({ chartFilterValue, regionFilterValue, selectFromToDates, refreshBtn }) => {
  const [chartData, setChartData] = useState({});
  const [supportCaseData, setSupportCaseData] = useState([]);
  const [options, setOptions] = useState({});
  const [isChartShow, setIsChartShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [notification, setNotification] = useState();

  useEffect(() => {
    if ((selectFromToDates.startDate === "" && selectFromToDates.endDate === "") || (refreshBtn === true)) {
      getReasons();
    }
  }, [chartFilterValue, regionFilterValue, selectFromToDates, refreshBtn]);

  const getReasons = async () => {
    setIsLoading(true);
    let responseArray = [];
    let reqBody;
    try {
      if (selectFromToDates.startDate !== "" && selectFromToDates.endDate !== "") {
        reqBody = {
          fromDate: selectFromToDates.startDate,
          toDate: selectFromToDates.endDate,
          region: regionFilterValue,
        };
      } else {
        reqBody = {
          filter: chartFilterValue,
          region: regionFilterValue,
        };
      }
      responseArray = await supportCaseType.getSupportCaseType(reqBody);
      setIsLoading(false);
      if (responseArray.data.statusCode === "200") {
        if (responseArray.data.data.typeCountList.length !== 0) {
          setSupportCaseData(responseArray.data.data.typeCountList);
          let data = responseArray.data.data.typeCountList;
          if (data.length > 0) {
            const chartData = {
              labels: data.map((el) => el.date),
              datasets: data[0].typeList.map((el, index) => {
                return {
                  label: el.type,
                  backgroundColor: Colors[index],
                  borderColor: Colors[index],
                  data: data.map((el) => el.typeList[index].count),
                };
              }),
            };
            setChartData(chartData);
            const options = {
              maintainAspectRatio: false,
              aspectRatio: 0.8,
              plugins: {
                legend: {
                  labels: {
                    fontColor: "lightgray",
                  },
                },
                datalabels: {
                  display: true,
                  color: "black",
                  font: {
                    size: 12,
                    weight: "bold",
                  },
                },
              },
              scales: {
                x: {
                  ticks: {
                    color: "brown",
                    font: {
                      weight: 500,
                    },
                  },
                  grid: {
                    display: false,
                    drawBorder: false,
                  },
                },
                y: {
                  ticks: {
                    color: "brown",
                  },
                  grid: {
                    color: "lightgray",
                    drawBorder: false,
                  },
                },
              },
            };
            setOptions(options);
          }
          setIsLoading(false);
        } else {
          setSupportCaseData(responseArray.data.data.typeCountList);
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
        notify("Unable to fetch data due to an unexpected error", "error", true);
      }
    } catch (err) {
      console.log("error", err);
      setIsLoading(false);
      notify("Unable to fetch data due to an unexpected error", "error", true);
    }
    return responseArray;
  };

  const onErrorNotificationClose = () => {
    setNotification(null);
  };

  const notify = (content, type, show) => {
    setNotification(
      <CPNotification isOpen={show} notificationType={type} height="auto" width="90%" closeButton={true} onClose={() => onErrorNotificationClose()}>
        <Wrapper fontFamily="neue-haas-grotesk-text" fontSize="0.875rem">
          {content}
        </Wrapper>
      </CPNotification>
    );
    setTimeout(() => {
      setNotification(null);
    }, 5000);
  };

  const buttonHandle = () => {
    setIsChartShow(!isChartShow);
  };

  return (
    <MainWrapper>
      <div style={{ marginBottom: "20px", marginLeft: "10px" }}>{notification}</div>
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        <ComparisionViewButton isChartShow={isChartShow} onClick={() => buttonHandle()}>
          Support Case Types
        </ComparisionViewButton>
      </div>
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        {isChartShow && (
          <ChartWrapper>
            <div style={{ position: "relative", width: "1.5rem", height: "1.5rem", left: "50%" }}>
              <Loader active={isLoading} fullscreen={false} />
            </div>
            {supportCaseData.length !== 0 ? (
              <Chart type="bar" data={chartData} options={options} width="600px" height="350px" plugins={[ChartDataLabels]} />
            ) : (
              "No Data Available"
            )}
          </ChartWrapper>
        )}
      </div>
    </MainWrapper>
  );
};

SupportCaseTypes.propTypes = {
  chartFilterValue: PropTypes.any.isRequired,
  regionFilterValue: PropTypes.any.isRequired,
  selectFromToDates: PropTypes.shape({
    startDate: PropTypes.string,
    endDate: PropTypes.string,
  }).isRequired,
  refreshBtn: PropTypes.bool.isRequired,
};

export default SupportCaseTypes;